import React, { useState, useEffect } from "react";
import "../styles/SignupPopup.css";
import { jwtDecode } from "jwt-decode";
import { useNavigate } from "react-router-dom";
import { fetchSubscriptionLoginUserApi } from "../api/api";

const Loginpopup = ({ showPopup, handleClose, setToken, handleClose2, withoutloginredirect, setShowForgot,  customError, customId}) => {
  const username = sessionStorage.getItem("username");
  const rememberMeSession = sessionStorage.getItem("rememberMe");
  const [email, setEmail] = useState(username || customId);
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [rememberMe, setRememberMe] = useState(rememberMeSession ? true : false);
  const [error, setError] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  

  const navigate = useNavigate();

  const getTokenExpireTime = (token) => {
    try {
      const decoded = jwtDecode(token);
      if (decoded.exp) {
        return decoded.exp * 1000;
      }
      return null;
    } catch (error) {
      console.error("Invalid token:", error);
      return null;
    }
  };

  const handleForgotClick = () => {
    setShowForgot(true);
    handleClose()
};


  

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (loading) return;

    setLoading(true);
    setError("");

    if (!email || !password) {
      setError("Please enter both email and password");
      setLoading(false);
      return;
    }

    try {
      const response = await fetchSubscriptionLoginUserApi(email, password);

      if (response.statuscode === 200) {
        sessionStorage.setItem("loginData", JSON.stringify(response.data));
        const token = response.data.token;
        const decodedExpiry = getTokenExpireTime(token);
        let expiryTime = decodedExpiry;
        if (rememberMe) {
          expiryTime = Date.now() + 30 * 24 * 60 * 60 * 1000; 
        }
        
        sessionStorage.setItem("tokenId", token);
        sessionStorage.setItem("expiryId", expiryTime.toString());
        sessionStorage.setItem("rememberMe", rememberMe ? "true" : "false");
        sessionStorage.setItem("subscriptionid", response.data.subscriptionid);
        sessionStorage.setItem("subscriptionStatus", response.data.status);
        sessionStorage.setItem("usertypeid", response.data.usertypeid);
        sessionStorage.setItem("username", response.data.username);
        sessionStorage.setItem("subscriberid", response.data.userid);
        setToken(token);
        handleClose2();
        setTimeout(() => {
            withoutloginredirect ? navigate(`/${withoutloginredirect}`) : navigate("/");
        }, 100);
      } else if (response.statuscode === 404) {
        setError(response.message);
      } else {
        setError("Invalid email or password");
      }
    } catch (err) {
      console.error("Login error:", err);
      setError("Something went wrong. Please try again.");
    }

    setLoading(false);
  };

  // ✅ Auto-refresh expiry on user activity
  useEffect(() => {
    const resetExpiry = () => {
      const token = sessionStorage.getItem("tokenId");
      const remember = sessionStorage.getItem("rememberMe") === "true";

      if (token && remember) {
        const newExpiry = Date.now() + 30 * 24 * 60 * 60 * 1000; // extend 30 days
        sessionStorage.setItem("expiryId", newExpiry.toString());
      }
    };

    window.addEventListener("click", resetExpiry);
    window.addEventListener("keypress", resetExpiry);

    return () => {
      window.removeEventListener("click", resetExpiry);
      window.removeEventListener("keypress", resetExpiry);
    };
  }, []);

  // ✅ Check expiry on page load
  useEffect(() => {
    const expiry = sessionStorage.getItem("expiryId");
    if (expiry && Date.now() > Number(expiry)) {
      sessionStorage.clear();
      navigate("/login");
    }
  }, [navigate]);



  // 🚨 move conditional return *after* hooks
  if (!showPopup) return null;

  return (
    <div className="signup-popupContent">
      {/* Title */}
      <h2 className="signup-title">Log In</h2>

      <form onSubmit={handleSubmit} className="signup-form-popup">
        {error && <p className="AF-error-message" style={{color:'red'}}>{error}</p>}
        {customError && <p className="AF-error-message" style={{color:'red'}}>{customError}</p>}

        <label style={{ textAlign: "left" }}>Email</label>
        <input
          type="email"
          placeholder="Enter email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          autoComplete="off"
          autoCorrect="off"
          autoCapitalize="off"
          spellCheck="false"
          inputMode="email"
        />

        <label style={{ textAlign: "left" }}>Password</label>
        <div className="password-wrapper">
          <input
            type={showPassword ? "text" : "password"}
            placeholder="Enter password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            autoComplete="new-password"
            autoCorrect="off"
            autoCapitalize="off"
            spellCheck="false"
          />
          <span
            className="password-toggle"
            onClick={() => setShowPassword((prev) => !prev)}
        >
            {showPassword ? "Hide" : "Show"}
        </span>
        </div>

        <div className="remember-me">
          <input
            type="checkbox"
            id="rememberMe"
            checked={rememberMe}
            onChange={() => setRememberMe(!rememberMe)}
          />
          <label htmlFor="rememberMe">Remember me</label>
        </div>

        <div className="auth-row">
          <button type="submit" className="signup-loginBtn" disabled={loading}>
           {loading ? "Logging in..." : "Log In"}
          </button>
          
          {/*  */}
        </div>
        <div>
          <button 
            type="button" 
            className="signup-loginBtn" 
            onClick={() => { handleClose()}}
          >
            Don’t have an account ? Sign up free 
          </button>
        </div>
      </form>

      {/* Footer Links */}
      <div className="signup-footer">
        <a
            onClick={handleForgotClick}
            className="signup-footer-left"
          >
            Forgot details?
          </a>
        {/* <a
          onClick={() => { handleClose()}}
          className="signup-footer-left"
        >
            Don’t have an account? Sign up free 
          </a> */}
          <a 
            onClick={() => {
              handleClose();
              handleClose2()
              navigate("/pricing");
            }} 
            className="signup-footer-right">
            Want full access? See our Pro Plan
          </a>
      </div>


      
    </div>
  );
};

export default Loginpopup;
